<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <div class="row">
              <div class="col-12">
                <button class="close close-btn" @click="close()" v-if="!needsOxygenAccountOrMFA">
                  <font-awesome-icon icon="times" />
                </button>
                <h4 style="font-family: artifaktElementBold">Special Terms</h4>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12 body-content">
                <p v-if="needsOxygenAccountOrMFA">{{ this.getUser.firstName }}, next you will have to agree to Autodesk
                  Terms of Use to complete your account setup, or complete MFA as per Autodesk requirements.
                </p>
                <p>Note that although the Offering Type for the offering you will receive self-identifies as "Trial" or
                  "NFR", your use is NOT limited to "non-commercial evaluation purposes".</p>
              </div>
            </div>
          </div>
          <div class="modal-footer" v-if="needsOxygenAccountOrMFA">
            <div class="row">
              <div class="offset-md-4 col-md-4">
                <button class="modal-default-button btn flat-green-btn" @click="request()">Confirm</button>
              </div>
              <div class="col-md-4">
                <button class="modal-default-button btn flat-grey-btn" @click="close()">Decline</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { AuthClient as AuthClientSdk } from '@adsk/identity-web-sdk';
import { mapGetters, mapMutations } from "vuex";
import * as CONSTANTS from "../constants.js";

export default {
  name: "SpecialTermsModal",
  props: {
    needsOxygenAccountOrMFA: Boolean
  },
  computed: {
    ...mapGetters(['getUser']),
  },
  data: function () {
    return {
      CONSTANTS,
      showModal: false
    };
  },
  methods: {
    ...mapMutations(['setAPSToken']),
    async request() {
      try {
        let client = new AuthClientSdk({
          ...CONSTANTS.BASE_APS_OPTIONS,
          authoptions: {email: this.getUser.email}
        })
        const token = await client.loginWithPopup()
        this.setAPSToken(token)
      }
      catch (e) {
        console.log(JSON.stringify(e))
      }
      this.close()
    },
    close() {
      this.$emit("close");
    },
  }
};
</script>

<style scoped>
.btn {
  height: 43px;
}

.close-btn {
  font-size: 18px;
}

.modal-header {
  display: block;
  padding: 0 0;
  padding-bottom: 10px;
  margin-top: 10px;
  margin-bottom: 20px;
}

.modal-header h4 {
  font-weight: bold;
  font-size: 25px;
  color: #575757;
  margin-top: 20px;
  margin-bottom: 10px;
}

.modal-body {
  padding: 0;
}

.modal-body p {
  margin-bottom: 5px;
}

.body-content {
  margin-bottom: 25px;
}

.modal-footer {
  margin-top: 20px;
  padding: 0;
}

.flat-blue {
  background: #fff;
  color: #666666;
  border: 1px black solid;
  border-radius: 4px;
  padding-top: 3px;
  padding-bottom: 3px;
  font-size: 14px;
}

.flat-blue:focus {
  border: 2px black solid !important;
  border-radius: 4px;
  color: black !important;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  padding-top: 5px !important;
  width: 500px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: "artifaktElementRegular";
}

.modal-footer {
  display: block;
  border-top: none;
}

.modal-default-button {
  float: right;
  padding: 10px 30px;
  width: 100%;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

@media (max-width: 767px) {
  .modal-default-button {
    margin-bottom: 10px;
  }
}

@media (max-width: 500px) {
  .modal-container {
    width: 100%;
  }
}
</style>
